<template>
  <el-popover v-model="visible" placement="bottom-end" width="280" trigger="click" popper-class="locale-popover">
    <div class="locale-panel">
      <strong>{{ $t("locale.title") }}</strong>
      <label>{{ $t("common.language") }}</label>
      <el-select v-model="form.language" size="small" popper-class="locale-select-dropdown">
        <el-option v-for="item in localeOptions" :key="item.code" :label="item.name" :value="item.code" />
      </el-select>
      <label>{{ $t("common.country") }}</label>
      <el-select v-model="form.country" size="small" filterable popper-class="locale-select-dropdown">
        <el-option v-for="item in countryOptions" :key="item.code" :label="item.name" :value="item.code" />
      </el-select>
      <button type="button" class="locale-save" @click="save">{{ $t("common.save") }}</button>
    </div>
    <button slot="reference" type="button" class="locale-trigger" :aria-label="$t('locale.title')">
      <i class="el-icon-s-promotion" /><span>{{ shortLanguage }}</span>
    </button>
  </el-popover>
</template>

<script>
import { countryOptions, localeOptions, localeState, updateLocale } from "../i18n"

export default {
  name: "LocaleSwitcher",
  data() {
    return { visible: false, localeOptions, countryOptions, form: { ...localeState } }
  },
  computed: {
    shortLanguage() {
      return this.form.language.split("-")[0].toUpperCase()
    }
  },
  methods: {
    save() {
      updateLocale(this.form)
      this.visible = false
    }
  }
}
</script>
